module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/diseases/organ-8533cd8581db51005bbfd62545806b50.png";